export function submitReview(data) {
  return {
    type: 'SEND_REVIEW',
    payload: data,
    meta: {
      offline: {
        effect: {
          method: 'POST',
          query: {
            mock: false,
            base: '/claims/request',
          },
        },
        commit: {
          type: 'SEND_REVIEW_COMMIT',
        },
        rollback: {
          type: 'SEND_REVIEW_ROLLBACK',
        },
      },
    },
  }
}
